
export default function($form) {
  var extForm=$form.__originalExtForm;

  if (!$form.isValid(true)) {
    return;
  }
  let btnName = extForm.action;
  extForm.setBtnLoading(true, btnName);

  function complete(data,err){
    extForm.setBtnLoading(false, btnName);
    if(err){
      return;
    }
    let p ={
      action:extForm.action,
      taskId:data.taskId,
      appId:extForm.appId,
      formId:extForm.formId,
      entityId:extForm.entityId,
      businessId:data.businessId,
      batchId:data.batchId,
      draftsDocId:data.draftsDocId,
      activity:extForm.activity,
      comment:extForm.commentId ? [{
        id: extForm.commentId,
        content: extForm.comment,
        category: extForm.commentCategory
      }] : [],
      formOpenSource:extForm.formOpenSource,
      defaultSelectActivity:extForm.activity && extForm.activity.defaultSelectActivityId
    };
    p.businessName = $form.getValueByName(extForm.fieldMapping.businessName);
    if(extForm.extParams && extForm.extParams.fullAuthType){
      p.fullAuthType = extForm.extParams.fullAuthType;
    }
    p.flowLoadNode = function(flow,treeComp,jsTreeEl,data){
      $form.fireEvent("flowLoadNode", this,flow,treeComp,jsTreeEl,data)
    }
    p.beforedocomplete = function(params,callback){
      return $form.fireEvent("beforedocomplete", p,params,this, callback.bind(this))
    }
    p.beforeshowdialog = function(){
      return $form.fireEvent("beforeshowcompletedialog", p,this)
    }
    if ($form.fireEvent("beforecomplete", p,extForm, continuation.bind(this)) === false) {
      return false;
    }
    function continuation(){
      extForm.setBtnLoading(true, btnName);
      function afterComplete(params,res){

        if ($form.fireEvent("aftercomplete", params,res, cb.bind($form)) === false) {
          return false;
        }
        cb();
        function cb(){
          extForm.formActionComplete();
        }
      }
      PF.show('flowComplete',p,afterComplete,function beforeClose(){
        extForm.setBtnLoading(false, btnName);
      });
    }
    continuation.call(this);
  }

  if (extForm.isNotifyTask() || extForm.isReadOnlyTask()) {
    complete(extForm);
  } else {
    extForm.startProcess(complete,"complete");
  }
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-complete.js